import React from 'react';

import AniSlideUpBlur from '@/components/shared/animations/basic/AniSlideUpBlur';

import Area from '../../layouts/shared/Area';

type Props = {
  title: React.ReactNode;
};

export default function Subtop({ title }: Props) {
  return (
    <div>
      <Area>
        <AniSlideUpBlur>
          <h2 className="pt-10 text-[32px] font-bold leading-[120%] tracking-[-0.64px] text-apps-coreGrayBlack md:text-[clamp(32px,5vw,60px)] lg:pt-[clamp(40px,8.333vw,100px)] lg:leading-[140%] lg:tracking-[-1.2px]">
            {title}
          </h2>
        </AniSlideUpBlur>
      </Area>
    </div>
  );
}
